var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:_vm.classBtnType,on:{"click":function($event){return _vm.$emit('clicked')}}},[(_vm.loading)?_c('span',[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }